<template>

<div>
<!-- <pre>{{get_userinfo_data}}</pre> -->
  <div class="the-navbar__user-meta flex items-center" v-if="get_userinfo_data">
<!-- 
   <pre> {{get_userinfo_data}} </pre> -->

    <div class="text-right leading-tight hidden sm:block">
      <!-- {{get_userinfo_data}} -->
      <p class="font-semibold">{{ get_userinfo_data | fullName }}</p>
      <small>{{ get_userinfo_data.role_name === 'root admin' ? 'Root Admin' : get_userinfo_data.role_name }}</small>
    </div>

    <div class="cursor-pointer cstm_dropdown_holder" @click="dropdown_show = !dropdown_show" v-click-outside="outside">

      <div class="con-img ml-3">

        <img v-if="get_userinfo_data.picture" key="onlineImg" :src="get_userinfo_data.picture" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block object-contain" />
        <img v-else key="onlineImg" :src="default_image" alt="user-img" width="40" height="40" class="1 rounded-full shadow-md cursor-pointer block object-contain" />
      </div>

      <div class="vx-navbar-dropdown cstm_dropdown_menu" :class="[dropdown_show ? 'dropdown_menu_show' : '']">
        <ul style="min-width: 185px">

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/user-settings').catch(() => {})">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Profile</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/email').catch(() => {})">
            <feather-icon icon="MailIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Inbox</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/tasks-project').catch(() => {})">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/pages/chat').catch(() => {})">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <vs-divider />
          
          <!-- <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/apps/eCommerce/wish-list').catch(() => {})">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li> -->

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push({name: 'reset-password'}).catch(() => {})">
            <feather-icon icon="LockIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Reset Password</span>
          </li>

          <!-- <vs-divider class="m-1" /> -->
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="workspaceSwitching">
            <feather-icon icon="RepeatIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Switch Workspace</span>
          </li>

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
    </div>


</template>

<script>
import {mapGetters} from 'vuex'

// import firebase from 'firebase/app'
// import 'firebase/auth'
export default {
  data () {
    return {
      default_image:'',
      dropdown_show: false
    }
  },
  created () {
    this.default_image = process.env.VUE_APP_WORKSPACE_DEFAULT_IMAGE

  },
  computed: {
    ...mapGetters(
      ['get_userinfo_data']
    ),
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  filters:{
    fullName (value) {
      if (value.last_name) {
        return `${value.first_name} ${value.last_name}`

      } else {
        return `${value.first_name}`
      }
    }
  },
  methods: {
    async logout () {
      this.$vs.loading({
        type: 'corners'
      })
      this.$store.dispatch('Logout')
        .then((response) => {
          
          localStorage.removeItem('can_delete')
          localStorage.removeItem('show')
          localStorage.removeItem('role_permission')
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Logged Out',
            text: response,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          localStorage.clear()

          this.$router.push('/pages/login').catch(() => {})

          this.$vs.theme({
            primary : '#3ac2d4',
            secondary: '#f67c7e',
            heading: '#2c2c2c',
            text: '#626262'
          })
        })
        .catch(error => {
          
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    // if user is logged in via auth0
    //   if (this.$auth.profile) this.$auth.logOut()

    //   // if user is logged in via firebase
    //   const firebaseCurrentUser = firebase.auth().currentUser

    //   if (firebaseCurrentUser) {
    //     firebase.auth().signOut().then(() => {
    //       this.$router.push('/pages/login').catch(() => {})
    //     })
    //   }
    //   // If JWT login
    //   if (localStorage.getItem('accessToken')) {
    //     localStorage.removeItem('accessToken')
    //     this.$router.push('/pages/login').catch(() => {})
    //   }

    //   // Change role on logout. Same value as initialRole of acj.js
    //   this.$acl.change('admin')
    //   localStorage.removeItem('userInfo')

    //   // This is just for demo Purpose. If user clicks on logout -> redirect
    //   this.$router.push('/pages/login').catch(() => {})
    // }
    workspaceSwitching () {
      this.$router.push('/pages/switch').catch(() => {})
    },
    outside () {
      this.dropdown_show = false
    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || !el.contains(e.target) && el !== e.target) {
          /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
}
</script>
